import * as React from "react";
import ProgressiveImage from "react-progressive-image-loading";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

type ClassNames = "img";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    img: {
        margin: theme.spacing.unit * 2,
        boxShadow: "0 1px 8px 0 rgba(43,49,58,0.05), 1px 12px 25px 0 rgba(43,49,58,0.1)",
        borderRadius: 18
    }
});

interface ScreenProps {
    style: React.CSSProperties,
    preview: string,
    regular: string,
    full: string
}

class Screen extends React.Component<WithStyles<ClassNames> & ScreenProps> {

    public renderImage = (src: string, stl: React.CSSProperties) => (
        <img className={this.props.classes.img} style={{...stl, width: 240 }} {...{src}} />
    );

    public render() {
        const {style, preview, regular} = this.props;
        return (
            <div {...{style}}>
                <ProgressiveImage
                    preview={preview}
                    src={regular}
                    render={this.renderImage}
                />
            </div>
        );
    }
}

export default withStyles(styles)<ScreenProps>(Screen);



// WEBPACK FOOTER //
// ./src/elements/Screen.tsx